import * as React from 'react';
import './ExpandableRowMobile.scss';
import localeFormatingInstance from 'src/translation/localeFormating';
import { IReturnDetail } from 'src/services/returns/typings';
import IconMessage from 'src/components/common/IconMessage';

interface IExpandableRowMobileProps {
  returnDetail: IReturnDetail;
  t?: any;
}

const ExpandableRowMobile: React.FC<IExpandableRowMobileProps> = ({
  returnDetail,
  t
}) => {
  return (
    <div className="rp-expandable-row-mobile">
      <div className="container-fluid">
        <div className="row rp-expandable-row-mobile-headers">
          <div className="col-4">
            <p>{t('myReturns.partNo')}</p>
          </div>
          <div className="col-4">
            <p>{t('myReturns.invoiceNo')}</p>
          </div>
          <div className="col-4">
            <p>{t('myReturns.invoiceDate')}</p>
          </div>
        </div>
        <div className="row">
          <div className="col-4">
            <p>{returnDetail.partNumber}</p>
          </div>
          <div className="col-4">
            <p>{returnDetail.invoiceNumber}</p>
          </div>
          <div className="col-4">
            <p>
              {localeFormatingInstance.formatDate(
                returnDetail.invoiceDate,
                'short'
              )}
            </p>
          </div>
        </div>
        <div className="row rp-expandable-row-mobile-headers --second-row">
          <div className="col-3">
            <p>{t('myReturns.price')}</p>
          </div>
          <div className="col-3">
            <p>{t('myOrders.qty')}</p>
          </div>
          <div className="col-3">
            <p>{t('myReturns.mobile.rFee')}</p>
          </div>
          <div className="col-3 break-word-custom">
            <p>{t('myReturns.creditAmount')}</p>
          </div>
         
        </div>
        <div className="row">
          <div className="col-3">
            <p>{localeFormatingInstance.formatCurrency(returnDetail.price)}</p>
            {returnDetail.hasCoreIncluded && (
              <IconMessage
                icon={'rpds-error'}
                message={'This price includes a Core Charge'}
              />
            )}
          </div>
          <div className="col-3">
            <p>{returnDetail.returnQuantity}</p>
          </div>
          <div className="col-3">
            <p>{returnDetail.restockingFee}%</p>
          </div>
          <div className="col-3">
            <p>
              {localeFormatingInstance.formatCurrency(
                returnDetail.returnAmount
              )}
            </p>
          </div>
          
        </div>
        {returnDetail.lineStatus!==null &&      
        <React.Fragment>
        <div className="row rp-expandable-row-mobile-headers" style={{ marginTop:"12px"}}>
          <div className="col-4">
            <p>{t('myReturns.statusHeader')}</p>
          </div>
        </div>
        <div className="row">
          <div className="col-4">
            <p>{returnDetail.lineStatus}</p>
            {returnDetail.rejectionReason!==null &&   
             <p>(Reason - {returnDetail.rejectionReason})</p>
            }
          </div>
        </div>
        </React.Fragment>
        }
      </div>
    </div>
  );
};

export default ExpandableRowMobile;
